export function getApplicableRegulations() {
    return ['ccpa'];
}
